module.exports = __webpack_public_path__ + "static/logo-name-ba1df2a02db6420019def4f7e79b4cbf.png";